export default function pluralize(word: string, count?: number) {
  if (count == 1) {
    return word;
  } else if (word.endsWith('f')) {
    return word.replace(/f$/, 'ves');
  } else if (word.endsWith('s')) {
    return `${word}es`;
  } else {
    return `${word}s`;
  }
}
